"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTrackerErrorT = exports.StatusTrackerError = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_id_js_1 = require("../../solarxr-protocol/datatypes/tracker-id.js");
/**
 * Trackers with error state
 */
class StatusTrackerError {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusTrackerError(bb, obj) {
        return (obj || new StatusTrackerError()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusTrackerError(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusTrackerError()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackerId(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    trackerIdLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startStatusTrackerError(builder) {
        builder.startObject(1);
    }
    static addTrackerId(builder, trackerIdOffset) {
        builder.addFieldOffset(0, trackerIdOffset, 0);
    }
    static createTrackerIdVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTrackerIdVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endStatusTrackerError(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusTrackerError(builder, trackerIdOffset) {
        StatusTrackerError.startStatusTrackerError(builder);
        StatusTrackerError.addTrackerId(builder, trackerIdOffset);
        return StatusTrackerError.endStatusTrackerError(builder);
    }
    unpack() {
        return new StatusTrackerErrorT(this.bb.createObjList(this.trackerId.bind(this), this.trackerIdLength()));
    }
    unpackTo(_o) {
        _o.trackerId = this.bb.createObjList(this.trackerId.bind(this), this.trackerIdLength());
    }
}
exports.StatusTrackerError = StatusTrackerError;
class StatusTrackerErrorT {
    constructor(trackerId = []) {
        this.trackerId = trackerId;
    }
    pack(builder) {
        const trackerId = StatusTrackerError.createTrackerIdVector(builder, builder.createObjectOffsetList(this.trackerId));
        return StatusTrackerError.createStatusTrackerError(builder, trackerId);
    }
}
exports.StatusTrackerErrorT = StatusTrackerErrorT;
